import { Link } from "@remix-run/react";
import { groupRegionsData } from "custom-config/region.configs";
import { Mail } from "lucide-react"; // or wherever your Mail icon is from
import { useRegionConfig } from "~/store/regionConfigStore";

type RegionEmailProps = {
  className?: string;
  size?: number;
  title?: string;
  isIconVisible?: boolean;
  email: boolean;
  calenderUrl: boolean;
  prefix?: React.ReactNode;
};

export function RegionEmail({ title = "Enquire now", className = "", size = 20, email = true, calenderUrl = false, prefix }: RegionEmailProps) {
  const { regionConfig } = useRegionConfig();
  // Use case-insensitive comparison for codes
  const getLinkByRegion = (code: string): string | null => {
    const region = groupRegionsData.find((r) =>
      r.codes.some(c => c.toLowerCase() === code.toLowerCase())
    );
    return email ? (region?.email ?? null) : calenderUrl ? (region?.calenderUrl ?? null) : null;
  };

  const link = getLinkByRegion(regionConfig?.region);

  if (email && link) {
    return (
      <div className="flex items-center gap-2">
        {prefix && <span>{prefix}</span>}
        <button
          onClick={() => window.location.href = `mailto:${link}`}
          className={`flex items-center gap-2 ${className}`}
          type="button"
        >
          <Mail className="text-oh-dark-gray hover:text-on-black" size={size} />
          <span>{title}</span>
        </button>
      </div>
    );
  }

  if (calenderUrl && link) {
    return (
      <div className="flex items-center gap-2">
        {prefix && <span>{prefix}</span>}
        <Link
          to={link}
          target="_blank"
          className={`flex items-center gap-2 ${className}`}
          type="button"
        >
          <span className="underline">{title}</span>
        </Link>
      </div>
    );
  }

  return null;
}